<template>
<div class="main">
	<div class="banner" ref="case" @click="toBuy">
		<img src="../../images/dadibanner2.jpg" alt="">
	</div>
	<div class="tabs" ref="tabs">
		<div class="tabs-container" :class="{fixed:fixed}">
			<Tabs :value="tabName" @on-click="tabChange">
				<TabPane label="保障方案" name="case"></TabPane>
				<TabPane label="产品介绍" name="introduction"></TabPane>
				<TabPane label="理赔流程" name="claim"></TabPane>
			</Tabs>
			<div class="tabs-container-form" v-show="fixed">
				<Button type="primary" @click="toBuy">立即购买</Button>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">保障方案</div>
		<div class="center">
			<a v-if="remark" :href="remark" target="_blank">（职业类别表查看）</a>
		</div>
		<div class="detail-main">
			<div>
				<table class="productDetail-table">
					<tbody>
						<tr>
							<th class="width">保障内容</th>
							<th class="width">保障方案</th>
							<th>说明</th>
						</tr>
						<tr class="hoverTr">
							<th>身故赔付费用</th>
							<td>80万</td>
							<td></td>
						</tr>
						<tr class="hoverTr">
							<th>残疾赔付费用</th>
							<td>80万</td>
							<td>一级100%、二级90%、三级80%、四级70%、五级60%、六级50%、七级40%、八级30%、九级20%、十级10%</td>
						</tr>
						<tr class="hoverTr">
							<th>意外医疗费用</th>
							<td>20万</td>
							<td>每次事故每人医疗费绝对免赔额200元</td>
						</tr>
						<tr class="hoverTr">
							<th>误工费</th>
							<td>100元/人/天</td>
							<td>免赔3天，限180天，（住院期间160/人/天，非住院期间100元/人/天）</td>
						</tr>
						<tr class="hoverTr" ref="introduction">
							<th>职业类别</th>
							<td class="tdcenter" colspan="2">1-4类</td>
						</tr>
						<tr class="hoverTr">
							<th>附加24小时</th>
							<td class="tdcenter" colspan="2">可选</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">产品介绍</div>
		<div class="detail-main">
			<div>
				<table class="productDetail-table">
					<thead>
						<tr>
							<th>特别约定和条款</th>
						</tr>
					</thead>
					<tbody>
						<tr class="hoverTr">
							<td>1、本保单承保的被保险人雇员仅限与被保险人建立合法劳动或劳务关系的16-70周岁自然人（其中65-70周岁人员保费不变，投保人数限5%，仅承保死亡赔偿限额20万、医疗费用赔偿限额2万），被保险人与超过法定退休年龄的人员须签订劳务合同。本保单仅承保1-4类工种（其中4类工种投保数量限10%），如在出险时被保险人实际从事的职业分类等级高于本保单列明承保的职业分类等级的，保险人不承担保险责任且不退还保费。</td>
						</tr>
						<tr class="hoverTr">
							<td>2、本保单人员数量详见人员清单；本保单载明投保人自愿将投保人权益转让给雇主责任险保单内所列明的被保险人；全权授予雇主责任险保单内被保险人的权益。每份保单下的实际用工单位全部作为共同被保险人。</td>
						</tr>
						<tr class="hoverTr">
							<td>3、本保单所承保的实际用工单位仅限于山东地区。按月承保，人员可批增，不可批退，不可替换，承保单明细上必须体现雇用人员信息。按季度承保人员可批增，可替换，不可批退。承保单明细上必须体现雇用人员信息。</td>
						</tr>
						<tr class="hoverTr">
							<td>4、本方案不承担包含职业病在内的任何疾病和任何性质的精神损害赔偿责任。</td>
						</tr>
						<tr class="hoverTr">
							<td>5、本保单剔除2米以上高处作业人员。根据GB/T3608《高处作业分级》国家标准的规定，凡在有可能坠落的高处进行施工作业，当坠落高度距离基准面在2米及2米以上时，该项作业即称为高空（高处）作业。被保险人人员在从事特种作业工作时,必须持有国家安全生产监督管理部门签发的特种作业操作证或国家质量技术监督管理部门签发的特种设备作业上岗证，对于无证人员进行特种作业操作时发生的事故，保险人不负责赔偿。特种作业定义以《特种作业人员安全技术培训考核管理规定》为准。</td>
						</tr>
						<tr class="hoverTr">
							<td>6、本保单发生损失时员工所在单位与投保时列明的实际用工单位不符，不在赔偿范围内。</td>
						</tr>
						<tr class="hoverTr">
							<td>7、保险事故发生后，被保险人应在出险后48小时内及时报案。法定节假日顺延，积极履行出险后的通知义务，出险后需第一时间报案，对未能第一时间报案的案件，需提供出险时视频监控或能证明事故是在工作期间及工作场所出险的相应监控证明事故发生。出险后超过48小时报案的，致使保险事故的性质、原因、损失程度等难以确定的，保险人对无法确定部分或者因延迟报案导致损失增加部分，保险人不负责赔偿。</td>
						</tr>
						<tr class="hoverTr">
							<td>8、本保单不承保地质矿产业、航运业、渔业、钢结构行业、危险品制造业、建筑工程业、木材加工业、快递业（含外卖人员）、铸造业、锻造业、金属冶炼业、金属轧制业、钢/铁管生产业、道路运输、道路清洁行业中的三类职业类别以上人员。</td>
						</tr>
						<tr class="hoverTr">
							<td>9、本保单医疗相关保障及误工建休时间费用赔付限定为中华人民共和国境内合法经营的二级以上（含二级）公立医院或保险公司认可的其他医疗机构，如急诊至二级以下医院（需医保医院）治疗，仅限出险当日1000元以下紧急治疗。</td>
						</tr>
						<tr class="hoverTr">
							<td>10、误工费：最高160元/人/天（住院期间160/人/天，非住院期间100元/人/天，具体赔付标准与出险雇员工资两者以低者为准）限180天。（与伤残赔偿不可兼得）</td>
						</tr>
						<tr class="hoverTr">
							<td>11、雇员在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡且提供尸检报告后确定不是因为既往症引发死亡的属于保险责任，按其死亡约定限额的50%赔付 ；无法提供尸检报告的案件以及达到法定退休年龄的人员发生猝死的案件按其死亡约定限额的25%赔付。但因在事故前被保险人的雇员已存在以下症状的：2 级或以上高血压（收缩压≥160mmHg或舒张压≥100mmHg），冠心病，心肌病，心梗，风湿性心脏病，心瓣膜病，严重心律失常，心功能不全二级（含）以上；主动脉瘤，主动脉夹层；脑血管病，脑卒中，保险人不负责赔付。被保险人雇员因事故前已患有的疾病、传染病、分娩、堕胎、流产以及因这些疾病而施行内、外科治疗手术所致的伤、残或死亡属于保险人责任免除。</td>
						</tr>
						<tr class="hoverTr">
							<td>12、属于本保单项下人伤损失范围的，赔偿标准依据《工伤保险条例》计算，被保险人雇员发生属于工伤认定范围内的交通事故及其它有责任方的侵权事故导致死亡、伤残的，该保单作为补充责任存在，死亡赔偿金计算方式依据《工伤险保险条例》在每人人身伤亡责任限额内据实计算，伤残赔偿金计算方式依据《工伤保险条例》在每人人身伤亡责任限额与本保险条款附录《伤残等级赔偿比例表》中相应百分比乘积的数额内据实计算，取数额低者。涉及社会平均工资及本人工资计算理赔的，参考上一年度全国城镇私营单位就业人员平均工资计算。保险人对每个被保险人每次保险事故赔偿限额为2,000,000元。</td>
						</tr>
						<tr class="hoverTr">
							<td>13、每人死亡或伤残赔偿限额与企业实际应承担的赔偿金额，两者以低者为准。如保险人认为赔付伤残必须出具伤残鉴定报告的案件，伤残鉴定以出险人员康复出院180天后在保险人认可的司法鉴定机构评残的结果为准。事故性质由保险人据实判定，涉及死亡和伤残及群体出险的保险事故，保险人或投保人/被保险人/雇员对其有异议的和保险人有需要的以工伤认定书及有法律效力的相关证明为准。</td>
						</tr>
						<tr class="hoverTr">
							<td>14、 被保险人雇员发生属于工伤认定范围内且因交通事故导致死亡、伤残的，该保单作为补充责任存在。赔付标准在赔偿限额内参照《工伤险保险条例》计算。具体标准如下：（1）出险雇员获得的其他保险（不含该保单）和其侵权方赔偿金额之和≥该保单赔偿限额时，则该保单的保险人不再给予赔偿。（2）出险雇员获得其他保险（不含该保单）和其侵权方赔偿金额之和＜该保单赔偿限额时，则按照出险雇员所承担的责任比例设定免赔额：同等责任免赔50%、次要责任和无责任免赔70%，并以①与②两种计算金额低者为实际赔付金额：① 实际赔付金额=该保单约定项下计算的每人赔偿金额扣除员工获得其他保险（不含该保单）和其侵权方赔偿金额（如金额已小于等于零，则该保单的保险人不再给予赔偿）。② 实际赔付金额=该保单约定项下计算的每人赔偿金额*（1-免赔率）</td>
						</tr>
						<tr class="hoverTr">
							<td>15、评残标准参照GB/T16180-2014《劳动能力鉴定职工工伤与职业病致残等级标准》执行，伤残等级赔付限额按最高伤残赔偿限额乘以相对应的等级比例，即：一级100%、二级90%、三级80%、四级70%、五级60%、六级50%、七级40%、八级30%、九级20%、十级10%（赔偿限额与企业实际承担的赔偿金额，两者以低者为准），达到法定退休年龄人员的伤残鉴定按照《人体损伤致残程度分级》标准鉴定伤残等级，并依照鉴定等级赔付一次性伤残补助金。 医疗费用赔偿范围参照国家《工伤保险诊疗项目目录和药品目录》标准执行。</td>
						</tr>
						<tr class="hoverTr">
							<td>16、扩展24小时意外保险项目：仅限扩展员工在食堂，宿舍等企业区域内及雇主方安排员工从事的非工作时间非工作地点的合法活动造成的意外伤害。适用条款：附加24小时扩展保险条款；每人死亡限额20万，每人医疗费用限额2万。<span class="red">如若意外事故因交通事故，赔偿标准参照第14条执行。</span></td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="detail-main-text left pt40"><b>产品条款查看：</b></div>
			<div style="font-size: 14px;text-align: left;padding-left: 20px;">
				<p ref="claim">
					<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M2/%E4%B8%AD%E5%9B%BD%E5%A4%A7%E5%9C%B0%E8%B4%A2%E4%BA%A7%E4%BF%9D%E9%99%A9%E8%82%A1%E4%BB%BD%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8%E9%9B%87%E4%B8%BB%E8%B4%A3%E4%BB%BB%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE%EF%BC%882014%E7%89%88%EF%BC%89.doc" target="_blank" referrerpolicy="no-referrer">《中国大地财产保险股份有限公司雇主责任保险条款（2014版）》</a><br />
					<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M2/%E9%99%84%E5%8A%A024%E5%B0%8F%E6%97%B6%E6%89%A9%E5%B1%95%E4%BF%9D%E9%99%A9%E6%9D%A1%E6%AC%BE.docx" target="_blank" referrerpolicy="no-referrer">《附加24小时扩展保险条款》</a><br />
					<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M2/%E9%99%84%E5%8A%A0%E4%BC%A4%E6%AE%8B%E7%AD%89%E7%BA%A7%E8%B5%94%E5%81%BF%E6%AF%94%E4%BE%8B%E8%A1%A8%E8%B0%83%E6%95%B4%E4%BF%9D%E9%99%A9A.docx" target="_blank" referrerpolicy="no-referrer">《附加伤残等级赔偿比例表调整保险A》</a><br />
					<a href="https://file.haierbx.net/INDUSTRY_ENTERPRISE/CCIC_EMPLOYER_LIABILITY_M2/%E9%99%84%E5%8A%A0%E8%AF%AF%E5%B7%A5%E8%B4%B9%E7%94%A8%E8%B5%94%E5%81%BF%E8%AE%A1%E7%AE%97%E6%A0%87%E5%87%86%E8%B0%83%E6%95%B4%E6%9D%A1%E6%AC%BE.docx" target="_blank" referrerpolicy="no-referrer">《附加误工费用赔偿计算标准调整条款》</a>
				</p>
			</div>
		</div>
	</div>
	<div class="detail">
			<div class="detail-title">理赔流程</div>
			<div class="detail-main">
				<div class="detail-main-text">
					<p>
						第一步，报案：发生事故后48小时内，拨打95590电话报案。<br />
						第二步，审核：根据指引提交理赔资料，保险公司将及时进行审核、调查，根据情况通知寄送纸质材料。<br />
						第三步，结案：资料提交齐全后，最晚将在30日内完成审核结案。<br />
						第四步，支付：对属于保险责任且资料齐全的，保险公司将在赔付协议达成后10日内支付赔款。
					</p>
				</div>
			</div>
			<br>
			<br>
		</div>
	<TrackNotice companyName="中国大地财产保险股份有限公司青岛分公司" />
</div>
</template>
<script>
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
export default {
	components:{ TrackNotice },
	mixins:[ track ],
	data () {
		return {
			tabName:'info',
			fixed:false,
			remark:'',
			version:''
		}
	},
	mounted() {
		//2023.8.7增加回溯逻辑
		this.track_is_new = true;
		this.$nextTick(()=>{
			window.addEventListener("scroll",this.handleScroll);
			this.trackInit(); 
		})
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	created(){
		// 获取职业类别表
		this.getJob()
	},
	methods:{
		// 立即购买
		toBuy() {
			// if(this.getTimeState()){
			// 	this.$Modal.warning({
			// 		title: '提示',
            //         content: '今日已超过购买时间，无法购买，请明日再进行购买'
            //     });
			// 	return false
			// }
			//2023.8.7增加回溯逻辑
			this.stopRecord({
				is_new: true
			}).then(()=>{
				this.$router.push(`/companyGroupEmployerDadi/fillin?productCode=CCIC_EMPLOYER_LIABILITY_M2&productName=人资雇主责任保险2025年产品2&version=${this.version}`)
			})
		},
		getTimeState(){
			// 获取当前时间
			let timeNow = new Date();
			// 获取当前小时
			let hours = timeNow.getHours();
			// 设置默认文字
			let state= false;
			// 判断当前时间段
			if (hours > 21 && hours <= 24) {
				state= true;
			}
			return state;
		},
		// tab切换
		tabChange(val){
			this.$refs[val].scrollIntoView({
				behavior: "smooth",  // 平滑过渡
			})
		},
		// 定位到伤残费率表位置
		toSC(key) {
			this.$refs[key].scrollIntoView({
				behavior: "smooth",  // 平滑过渡
	  	  		block:    "center"  // 上边框与视窗顶部平齐。默认值
			})
		},
		// 监听滚动
		handleScroll() {
			//获取滚动时的高度
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > this.$refs.tabs.offsetTop) {
				this.fixed=true;
			}else{
				this.fixed=false;
			}
		},
		async getJob(){
			await this.$axios.post('/broker/dict/find.json',{
				bizId:'INDUSTRY_ENTERPRISE',
				companyId: '10157',
				dictCode:'work_type',
				productCode: 'CCIC_EMPLOYER_LIABILITY_M2',
			}).then((res) => {
				this.remark = res.remark;
				this.version = res.version;
			})
		}
	}
}
</script>
<style scoped lang="less">
	.width{
		width: 150px;
	}
    .main {
        margin-bottom: 30px;
    }

    .pb50 {
        padding-bottom: 50px;
    }

    .pt40 {
        padding-top: 40px;
    }

    .banner-container {
        position: absolute;
        font-size: 14px;
        text-align: center;
        width: 510px;
        top: 80px;
        left: 0;
        right: 0;
        color: #fff;

        .notes {
            margin-top: 10px;
        }

        &-title {
            font-size: 32px;
            color: #333;
        }

        &-case {
            font-size: 24px;
            line-height: 2;
            color: #318af0;
        }

        &-sub {
            font-size: 14px;
            color: #555;
            margin-top: 30px;

            span {
                margin-right: 5px;
            }
        }

        &-desc {
            font-size: 18px;
        }

        &-input {
            width: 300px;
            margin: 20px auto 0;
        }

        &-btn {
            margin-top: 30px;

            a {
                width: 240px;
            }
        }
    }

    .detail-title {
        font-size: 30px;
    }

    .detail-main {
        .center {
            font-size: 0;
        }

        &-title,
        &-text {
            // padding-left: 20px;
        }

        &-title {
            font-size: 18px;
        }

        &-text {
            line-height: 2;
        }
    }

    .tabs {
        display: block;
        height: 46px;

        &-container {
            padding: 10px 10px 0;
            background: #fff;
            height: 46px;
            overflow: hidden;
            position: relative;

            &-form {
                position: absolute;
                right: 10px;
                bottom: 5px;

                button {
                    display: inline-block;
                }
            }
        }

        .fixed {
            position: fixed;
            top: 100px;
            left: 0;
            right: 0;
            margin: auto;
            width: 1200px;
        }
    }

    .productDetail-table.sm {
        font-size: 13px;

        .fs16 {
            font-size: 16px;
        }

        td {
            padding: 8px;
        }
    }
	.tdcenter{
		text-align: center !important;
	}
    .hoverTr:hover {
        color: #fff;

        td {
            background: #77adf5;
        }

        .hoverDisabled {
            background: #fafafa;
            color: #333;
        }
    }

    .importantText {
        color: #77adf5;
    }

    .tit {
        font-size: 18px;
        margin: 10px 0;
    }
    .step-contain{
        display: flex;
        justify-content: space-between;
        .step-item{
            width: 26%;
        }

    }
    .step-con {
        margin-bottom: 20px;
    }
    .step-con .ivu-steps-item:last-child{
        flex: 1 !important;
    }
	.red{
		color: red;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/indexCCIC_M2.vue